<button class="rounded-button text-uppercase d-flex align-items-center justify-content-center {{btnClass}}"
        [disabled]="isDisabled"
        (click)="onClickButton($event)" [class.w-100]="fullWidth">
  <ng-content></ng-content>
  <span class="fw-medium">{{ label }}</span>
</button>
